import { Box, Heading, Image, Stack, Text } from "@chakra-ui/react";
import { AiFillStar } from "react-icons/ai";

const TutorCard = () => {
  return (
    <Box
      py={6}
      px={5}
      bg="white"
      mb={3}
      rounded="lg"
      transition="all"
      border="2px solid rgba(193,193,193,.1)"
      _hover={{ border: "2px solid #af117d", shadow: "lg" }}
    >
      <Stack alignItems="center" gap={6}>
        <Box position="relative">
          <Image rounded="lg" src="https://html.vecurosoft.com/educino/demo/assets/img/team/team-1-3.jpg" />
          <Stack
            py={2}
            px={1}
            width="max-content"
            bg="white"
            position="absolute"
            bottom="-19px"
            rounded="lg"
            flexDirection="row"
            alignItems="center"
            gap="0.2rem"
          >
            {[1, 2, 3, 4, 5].map((star) => (
              <AiFillStar fontSize="18px" key={star} color="#f6b800" />
            ))}
          </Stack>
        </Box>
        <Stack alignItems="center">
          <Heading as="h5" mb="5px" color="#000" fontSize="24px" fontWeight="bold">
            Ryan Castro
          </Heading>
          <Heading textTransform="uppercase" as="h5" mb="10px" color="#444444" fontSize="16px">
            Math Tutor
          </Heading>
          <Text color="#444444" textAlign="center" mb="20px" fontSize="16px">
            {" "}
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam error voluptatem reiciendis. Assumenda
            laudantium,
          </Text>
        </Stack>
      </Stack>
    </Box>
  );
};

export default TutorCard;
